/**
 * Shared Home Design Event route path used by client and route modules.
 */
export const HDE_PAGE_PATH = '/home-design-event';

/** Inline validation shown when the user tries to continue without ticking HDE marketing consent. */
export const HDE_MARKETING_CONSENT_ERROR_MESSAGE =
    'Please tick the box to continue with registration';
export const HDE_MODAL_PARAM = 'hde-modal';
export const HDE_SUBMITTED_PARAM = 'hde-submitted';
export const HDE_EVENT_ID_PARAM = 'hde-event-id';
